import React from 'react'
import {Provider} from 'react-redux'
import {
    Redirect,
    // BrowserRouter as Router,
    Route,
    Router,
    Switch
} from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'
import {I18nextProvider} from 'react-i18next'
import i18n from '../i18n'
import Home from '../containers/Home'
import Post from '../containers/Post'
import Posts from '../containers/Posts'

// FIXME: check WP slug allowed chars, debug regexps


// required to sync route change with i18next.language
// language detection on initial load is handled by i18next-browser-languagedetector
// required to scroll to top on url change
const browserHistory = createBrowserHistory()

class Root extends React.Component {

    componentDidMount() {
        browserHistory.listen((location, action) => {
            const lng = location.pathname.split('/')[1] === 'pl' ? 'pl' : 'en'; // for english second condition change to 'en'
            if (lng !== (i18n.language /*|| window.localStorage.i18nextLng*/))
                i18n.changeLanguage(lng)
        })
        window.scrollTo(0, 0)
    }

    render() {
        const store = this.props.store;
        return (
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <Router history={browserHistory}>
                    <Switch>
                        <Redirect exact from="/" to="/pl"/>
                        <Route exact path="/:lng(pl|en)" component={Home}/>
                        <Route exact path="/:lng(pl|en)/posts/:page([0-9]+)?" component={Posts}/>
                        <Route exact path="/:lng(pl|en)/posts/:cat([-a-zA-Z0-9]+)/:page([0-9]+)?" component={Posts}/>
                        <Route exact path="/:lng(pl|en)/:slug([-_a-zA-Z0-9]+)" component={Post}/>                
                        {/* FIXME: this is only temp patch! it is buggy, slugs can be duplicated! */}
                        <Route exact path="/:lng(pl|en)/:parent/:slug([-_a-zA-Z0-9]+)" component={Post}/>
                    </Switch>
                </Router>
            </I18nextProvider>
        </Provider>)
    }
}

export default Root



// WEBPACK FOOTER //
// ./src/components/Root.js